var map = {
	"./about-us-banner.webp": 216,
	"./anniversary-banner-bm.webp": 1590,
	"./anniversary-banner-cn.webp": 1591,
	"./anniversary-banner-id.webp": 1592,
	"./anniversary-banner.webp": 1593,
	"./banner-01.jpg": 1594,
	"./banner-slot.jpg": 1595,
	"./bet-and-earn-banner-cn.webp": 1596,
	"./bet-and-earn-banner-indon.webp": 1597,
	"./bet-and-earn-banner-ms.webp": 1598,
	"./bet-and-earn-banner.webp": 1599,
	"./check-in-banner-cn.webp": 1600,
	"./check-in-banner-id.webp": 1601,
	"./check-in-banner-ms.webp": 1602,
	"./check-in-banner.webp": 1603,
	"./cny_2024-bm.webp": 1604,
	"./cny_2024-cn.webp": 1605,
	"./cny_2024.webp": 1606,
	"./epl-banner-cn.jpg": 1607,
	"./epl-banner-cn.webp": 1608,
	"./epl-banner-indo.jpg": 1609,
	"./epl-banner-indo.webp": 1610,
	"./epl-banner-ms.jpg": 1611,
	"./epl-banner-ms.webp": 1612,
	"./epl-banner.jpg": 1613,
	"./epl-banner.webp": 1614,
	"./games-banner-cn.webp": 1615,
	"./games-banner-id.webp": 1616,
	"./games-banner-ms.webp": 1617,
	"./games-banner.webp": 1618,
	"./lb-m-banner-cn.webp": 1619,
	"./lb-m-banner.webp": 1620,
	"./leaderboard-banner-cn.webp": 1621,
	"./leaderboard-banner.webp": 1622,
	"./lottery-banner.webp": 1623,
	"./lottery-banners-cn.webp": 1624,
	"./lottery-banners-id.webp": 1625,
	"./lottery-banners-ms.webp": 1626,
	"./lottery-banners.webp": 1627,
	"./lucky-spin-banner-cn.webp": 1628,
	"./lucky-spin-banner-ms.webp": 1629,
	"./lucky-spin-banner-vn.webp": 1630,
	"./lucky-spin-banner.webp": 1631,
	"./p2p-banner.webp": 1632,
	"./p2p-banners-cn.webp": 1633,
	"./p2p-banners-id.webp": 1634,
	"./p2p-banners-ms.webp": 1635,
	"./p2p-banners.webp": 1636,
	"./premier-league-banner-cn.webp": 1637,
	"./premier-league-banner.webp": 1638,
	"./promos-banner-cn.webp": 1639,
	"./promos-banner-indon.webp": 1640,
	"./promos-banner-ms.webp": 1641,
	"./promos-banner.webp": 1642,
	"./promos-detail-banner.jpg": 1643,
	"./side-bar-banner.jpg": 1644,
	"./slot-banners-cn.webp": 1645,
	"./slot-banners-ms.webp": 1646,
	"./slot-banners.webp": 1647,
	"./speed-banners-cn.webp": 1648,
	"./speed-banners-ms.webp": 1649,
	"./speed-banners.webp": 1650,
	"./uefa24-prediction-bm.webp": 1651,
	"./uefa24-prediction-cn.webp": 1652,
	"./uefa24-prediction-id.webp": 1653,
	"./uefa24-prediction.webp": 1654,
	"./vip-banner-cn.webp": 1655,
	"./vip-banner-id.webp": 1656,
	"./vip-banner-ms.webp": 1657,
	"./vip-banner-vn.webp": 1658,
	"./vip-banner.webp": 1659,
	"./winner-leaderboard-banner-cn.webp": 1660,
	"./winner-leaderboard-banner.webp": 1661,
	"./world-cup-banner-cn.webp": 1662,
	"./world-cup-banner.webp": 1663,
	"./world-cup-two-banner-cn.webp": 1664,
	"./world-cup-two-banner.webp": 1665,
	"./xmas_2023-bm.jpg": 1666,
	"./xmas_2023-cn.jpg": 1667,
	"./xmas_2023-id.jpg": 1668,
	"./xmas_2023.jpg": 1669,
	"./xmas_2024-bm.webp": 1670,
	"./xmas_2024-cn.webp": 1671,
	"./xmas_2024.webp": 1672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;